import React from 'react';
import ReactDOM from "react-dom";
import PopUp from './mainJS/popUp';
import './mainCSS/style.css';

export default function App() {
  return (
    <div>
    </div>
  );
}

function popUp() {
  if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
    const pop = new PopUp().getCookie('__POP');
    const popUp = new PopUp().popUpInfo(pop);
    setTimeout(function () {
      ReactDOM.render(
        <PopUp />,
        document.getElementById('popup')
      );
    }, 1000);
  }
}

window.onscroll = function () { popUp() };
